/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown>, total: NonNullable<unknown> }} Sage_Wry_Hen_MarchInputs */

const en_sage_wry_hen_march = /** @type {(inputs: Sage_Wry_Hen_MarchInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Showing ${i?.count} of ${i?.total} segments`)
};

const de_sage_wry_hen_march = /** @type {(inputs: Sage_Wry_Hen_MarchInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} von ${i?.total} Segmenten`)
};

/**
* | output |
* | --- |
* | "Showing {count} of {total} segments" |
*
* @param {Sage_Wry_Hen_MarchInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const sage_wry_hen_march = /** @type {((inputs: Sage_Wry_Hen_MarchInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sage_Wry_Hen_MarchInputs, { locale?: "en" | "de" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_sage_wry_hen_march(inputs)
	return de_sage_wry_hen_march(inputs)
});